export const TEMPLATE_CREATE_ERROR_OVERRIDES = {
    "Template.Support.NotAvailable": "templating.errors.supportNotAvailable",
};
